export default "__VITE_ASSET__938b2a6d__"